import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { InfoIcon } from '@zhuowenli/vue-feather-icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoButton',
  emits: [
  'click'
],
  setup(__props, { emit }) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn btn-inline",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createVNode(_unref(InfoIcon))
  ]))
}
}

})